import { firstPaidAt } from './activation';
import type { AdminTenantRow } from './types';
/** Explain which paid accounts cannot be placed in a first-payment cohort. */
export function retentionCoverage(rows: AdminTenantRow[]) {
  const real = rows.filter(row => !row.internal);
  const missing = real.filter(row => !firstPaidAt(row) && (
    (!row.founderPending && row.mrr > 0 && (row.subscriptionStatus === 'active' || row.subscriptionStatus === 'past_due')) ||
    (row.subscriptionStatus === 'canceled' && ((row.canceledMrr ?? 0) > 0 || row.commercialEvents?.some(event => event.type === 'baja' && (event.mrrDelta ?? 0) < 0)))
  ));
  const canceled = real.filter(row => row.subscriptionStatus === 'canceled');
  const scheduled = real.filter(row => row.cancelAt && (row.subscriptionStatus === 'active' || row.subscriptionStatus === 'past_due'));
  return { missing, canceled, scheduled };
}
